"use client"

import React from "react"
import { SafeAreaProvider } from "react-native-safe-area-context"
import { ThemeProvider as MUIThemeProvider } from "@mui/material"
import {
  AnalyticsProvider,
  AppConfigProvider,
  DeviceProvider,
  HTTPProvider,
  IntercomProvider,
  LocalizationProvider,
  LoggingProvider,
  ThemeProvider,
} from "@bullseye/components"
import {
  ErrorBoundary,
  ToastProvider,
  UnauthedAppModalProvider,
} from "@bullseye/ui"

import {
  apiBaseUrl,
  googlePlacesApiKey,
  intercomId,
  mapsBaseUrl,
  placesBaseUrl,
  segmentApiKey,
} from "../../constants"
import MuiTheme from "../../src/styles/MuiTheme"
import { PostHogProvider } from "../../src/components/PostHogProvider"

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NQDQMXN" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <PostHogProvider>
        <LocalizationProvider>
          <LoggingProvider>
            <SafeAreaProvider>
              <ToastProvider>
                <HTTPProvider config={{ apiBase: apiBaseUrl }}>
                  <AnalyticsProvider apiKey={segmentApiKey}>
                    <MUIThemeProvider theme={MuiTheme}>
                      <ThemeProvider>
                        <ErrorBoundary>
                          <DeviceProvider>
                            <IntercomProvider appId={intercomId} enabled={false}>
                              <AppConfigProvider
                                config={{
                                  mapsBaseUrl,
                                  placesBaseUrl,
                                  googlePlacesApiKey,
                                }}
                              >
                                <UnauthedAppModalProvider>
                                  {children}
                                </UnauthedAppModalProvider>
                              </AppConfigProvider>
                            </IntercomProvider>
                          </DeviceProvider>
                        </ErrorBoundary>
                      </ThemeProvider>
                    </MUIThemeProvider>
                  </AnalyticsProvider>
                </HTTPProvider>
              </ToastProvider>
            </SafeAreaProvider>
          </LoggingProvider>
        </LocalizationProvider>
      </PostHogProvider>
    </>
  )
}
